module.exports = __webpack_public_path__ + "abfbf6d1ed4fc7cfbe926ca30b8cc232.png";